import React from 'react';
import Icon from './AppIcon';
import Button from './ui/Button';

const EmptyStatePrompt = ({ 
  icon = 'Users',
  title = 'No Data Available',
  description = 'Get started by adding your first entry',
  actionLabel = 'Add Now',
  onAction,
  showAction = true 
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mb-6">
        <Icon name={icon} className="w-10 h-10 text-primary" />
      </div>
      
      <h3 className="text-xl font-semibold text-foreground mb-2">
        {title}
      </h3>
      
      <p className="text-muted-foreground max-w-md mb-6">
        {description}
      </p>
      
      {showAction && onAction && (
        <Button
          onClick={onAction}
          iconName="Plus"
          size="lg"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyStatePrompt;